<script type="text/babel">
import { Observable } from 'rxjs'
import HasSubscriptions from 'dashboard-js/mixins/HasSubscriptions'
import PreservesState from 'dashboard-js/mixins/PreservesState'
import clone from 'lodash-es/clone'

export default {
    mixins: [HasSubscriptions, PreservesState],

    props: {
        items: {},
        limit: {},
        teaserSlotSize: {
            default: 1,
        },
    },

    data() {
        return {
            displayItems: [],
            moreItems: [],
            currentBaseLimit: 0,
            currentShowMore: 0,
            preserveStateConfig: {
                preserveKey: key => ['currentShowMore'].indexOf(key) >= 0,
            },
        }
    },

    computed: {
        calculatedLimit() {
            return this.currentBaseLimit + this.currentShowMore
        },
    },

    watch: {
        calculatedLimit() {
            this.partitionItems()
        },

        items() {
            this.partitionItems()
        },

        limit(value) {
            this.currentBaseLimit = value
        },
    },

    created() {
        if (this.limit instanceof Observable) {
            this.subscribe(this.limit, limit => (this.currentBaseLimit = limit))
        } else {
            this.currentBaseLimit = this.limit
        }
    },

    methods: {
        partitionItems() {
            const items = clone(this.items)

            if (items.length > this.calculatedLimit) {
                this.displayItems = items.splice(0, this.calculatedLimit - this.teaserSlotSize)
                this.moreItems = items
            } else {
                this.displayItems = items
                this.moreItems = []
            }
        },

        showMore(amount = null) {
            amount = amount instanceof MouseEvent ? null : amount

            this.currentShowMore = this.currentShowMore + (amount || this.currentBaseLimit)
        },
    },

    render() {
        return this.$scopedSlots.default({
            displayItems: this.displayItems,
            moreItems: this.moreItems,
            showMore: this.showMore,
        })
    },
}
</script>
